import React from "react"; 
import { NavLink,withRouter } from "react-router-dom";
import {PRODUCTION_PATH,ORDERSEARCH_PAGE,CLERKLOGIN_PAGE,RETURNINSTRUCTIONS_PAGE} from "../../AppConfig";
import {logout} from '../../redux/actions/loginAction'; 
import Favicon from 'react-favicon';

import { connect } from 'react-redux';

class Header extends React.Component{  

  constructor(props) {
    super(props);  
    this.logOut = this.logOut.bind(this);
  }  
 
  logOut(){

      let moquiAPIToken = window.sessionStorage.getItem('storeClerkToken');
      let logoutInput = { "apiToken":moquiAPIToken,"storeId":window.sessionStorage.getItem('storeId')}
      this.props.logout(logoutInput,this.props);
       
  }

  render (){  

     let store = this.props.location.pathname.split('/')
     let storeId ='';
      if(store[2])
        storeId = store[2]; 
         
        // storeId = 'BLANK_NYC'

     window.sessionStorage.setItem('storeId',storeId);
     let backToSearch = PRODUCTION_PATH+storeId+ORDERSEARCH_PAGE;     
     let storeClerkToken = window.sessionStorage.getItem('storeClerkToken');
     
     let logo = <div className="logo text-center container">       
                   {this.props.storeDesign.returnSettingsMap &&
                   <React.Fragment>
                        {this.props.storeDesign.returnSettingsMap.homeURL!=='' ? (
                            <a href={this.props.storeDesign.returnSettingsMap.homeURL}><img src={this.props.storeDesign.returnSettingsMap.logo} alt="" className="img-fluid"/></a>
                            ) : (
                            <img src={this.props.storeDesign.returnSettingsMap.logo} alt="" className="img-fluid"/>
                        )}
                        <Favicon url={this.props.storeDesign.returnSettingsMap.favicon || this.props.storeDesign.returnSettingsMap.logo || '/favicon.ico'}/>
                   </React.Fragment>
                   }
                </div>

    return (   
        
        <header id="header" className="">           
          <div className="row">      
            {logo}
      
            <nav className="main-nav  text-center container-fluid no-padding" style={{display: this.props.location.pathname.includes(PRODUCTION_PATH+storeId+RETURNINSTRUCTIONS_PAGE) ? 'none' : 'block' }}>
            {/* If the current url is login page - avoid to load menu block */}
             {this.props.location.pathname !== PRODUCTION_PATH+storeId+CLERKLOGIN_PAGE &&
              <ul>

                {(this.props.location.pathname !== PRODUCTION_PATH+storeId+CLERKLOGIN_PAGE && !this.props.location.pathname.includes(PRODUCTION_PATH+storeId+RETURNINSTRUCTIONS_PAGE) &&
                  this.props.location.pathname !== PRODUCTION_PATH+storeId+ORDERSEARCH_PAGE && this.props.location.pathname !== '/') &&
                <li  className="active">
                <NavLink to={backToSearch}>Back To Search</NavLink>
                </li>}

                {storeClerkToken &&
                <li  className="active">              
                <a className="linkCursor" onClick={this.logOut}>Logout</a>
                </li>                
                } 
              </ul>
             }
            </nav>             
          </div>
        </header>  
      );  }
}
 
  
const mapStateToProps = (state) =>({
  storeDesign: state.storeSettingData.storeDesign
});  

export default connect(mapStateToProps, {logout})(withRouter(Header));

 



// WEBPACK FOOTER //
// ./src/components/Common/Header.js